import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z" />,
  'SouthWest',
);
